(function(){
  document.querySelectorAll('[data-picker]').forEach(function(stage){
    var photo=stage.querySelector('[data-photo]'),picked=stage.querySelector('[data-picked]');
    var btns=[].slice.call(stage.querySelectorAll('[role="radio"]'));
    var select=document.querySelector('[data-variant-select]');
    function pick(i,focus){
      var b=btns[i];if(!b)return;
      btns.forEach(function(x,j){x.setAttribute('aria-checked',j===i?'true':'false');x.tabIndex=j===i?0:-1});
      photo.src=b.dataset.img;photo.alt=b.dataset.name+' HOOKJAW Jawbreaker';
      picked.textContent=b.dataset.name+'. '+b.dataset.desc+(b.dataset.available==='false'?' Sold out right now.':'');
      if(select&&b.dataset.variant){select.value=b.dataset.variant}
      if(focus)b.focus();
    }
    btns.forEach(function(b,i){
      b.addEventListener('click',function(){pick(i)});
      b.addEventListener('keydown',function(e){
        var j=i;if(e.key==='ArrowRight'||e.key==='ArrowDown')j=(i+1)%btns.length;else if(e.key==='ArrowLeft'||e.key==='ArrowUp')j=(i+btns.length-1)%btns.length;else return;
        e.preventDefault();pick(j,true);
      });
    });
    var start=btns.findIndex(function(b){return b.getAttribute('aria-checked')==='true'});
    pick(start<0?0:start);
    document.querySelectorAll('[data-color-card]').forEach(function(card){
      card.style.cursor='pointer';
      card.addEventListener('click',function(){
        var i=btns.findIndex(function(b){return b.dataset.name===card.dataset.colorCard});
        if(i>-1){pick(i);stage.scrollIntoView({behavior:'smooth',block:'center'})}
      });
    });
  });
  document.querySelectorAll('[data-pdp]').forEach(function(pdp){
    var photo=pdp.querySelector('.pdp-photo'),price=pdp.querySelector('[data-price]');
    pdp.querySelectorAll('input[name="id"][type="radio"]').forEach(function(r){
      r.addEventListener('change',function(){if(r.dataset.img&&photo){photo.src=r.dataset.img;photo.removeAttribute('srcset')}if(price)price.textContent=r.dataset.price;
        try{var u=new URL(location.href);u.searchParams.set('variant',r.value);history.replaceState(null,'',u)}catch(e){}});
    });
    pdp.querySelectorAll('[data-thumb]').forEach(function(t){t.addEventListener('click',function(){if(photo){photo.src=t.dataset.thumb;photo.removeAttribute('srcset')}})});
  });
})();
